/**
 * Check if the given value is empty.
 * @param arg
 */
export default function empty(arg: unknown): boolean {
  if (arg === null || arg === undefined) {
    return true;
  }

  if (typeof arg === 'string') {
    return arg === '';
  }

  if (typeof arg === 'object') {
    if (Array.isArray(arg)) {
      return arg.length === 0;
    }

    return Object.keys(arg).length === 0;
  }

  return false;
}
